var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',[_vm._v("No fue posible cargar sus variables de entorno. La aplicación se detiene.")])
}
var staticRenderFns = []

export { render, staticRenderFns }